import { object, string, boolean } from 'yup';

export interface FormValues {
  goalDescription: string;
  isFinancialGoal?: boolean;
}

export const validation = object({
  goalDescription: string().required('Please enter the goal description'),
  isFinancialGoal: boolean().required('This field is required'),
});
